import { useState } from 'react';
import { Paper, Typography, Box, IconButton, Collapse } from '@mui/material';
import ChevroneUp from 'src/icons/ChevroneUp';

interface CollapsibleHintBlockProps {
    title: string;
    bullets: string[];
    example?: string[];
    initialOpen?: boolean;
}

export default function CollapsibleHintBlock({
    title,
    bullets,
    example,
    initialOpen = true,
}: CollapsibleHintBlockProps) {
    const [open, setOpen] = useState(initialOpen);
    return (
        <Paper
            elevation={0}
            sx={{ p: 2, borderRadius: 2, background: '#fff', mt: 1, boxShadow: 'none !important' }}
        >
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mb={open ? 2 : 0}
            >
                <Typography
                    variant="h5"
                    fontWeight={700}
                    color="primary.main"
                    sx={{ fontSize: 20 }}
                >
                    {title}
                </Typography>
                <IconButton
                    size="small"
                    onClick={() => setOpen((o) => !o)}
                >
                    <Box
                        sx={{
                            width: 16,
                            height: 16,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'transform 0.2s',
                            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                    >
                        <ChevroneUp />
                    </Box>
                </IconButton>
            </Box>
            <Collapse in={open}>
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {bullets.map((b, i) => (
                        <li key={i}>
                            <Typography
                                variant="body2"
                                sx={{ color: 'text.primary !important' }}
                            >
                                {b}
                            </Typography>
                        </li>
                    ))}
                </ul>
                {example && (
                    <Typography
                        variant="body2"
                        sx={{ mt: 2, color: 'text.secondary !important' }}
                    >
                        {example.map((e, i) => (
                            <span key={i}>
                                {e}
                                <br />
                            </span>
                        ))}
                    </Typography>
                )}
            </Collapse>
        </Paper>
    );
}
